<ng-container rtBlock="sc-home-hero">
    <section rtElem="stage" aria-label="Лестница по прокрутке" i18n-aria-label="@@homeHeroLabel" [rtMod]="{ playing: shownPart() >= 0 }">
        <!-- Four posters; the styles show the one named on <html>, and a hidden lazy image is never fetched -->
        @for (poster of posters; track poster.variant) {
            <picture rtElem="poster" [rtMod]="{ variant: poster.variant }">
                <source media="(max-width: 900px)" type="image/webp" [attr.srcset]="poster.small" />
                <img rtElem="poster-img" width="1920" height="1072" alt="" loading="lazy" decoding="async" [src]="poster.large" />
            </picture>
        }
        @for (part of parts(); track part.name; let index = $index) {
            <video
                rtElem="video"
                #video
                muted
                playsinline
                preload="none"
                aria-hidden="true"
                [rtMod]="{ shown: index === shownPart() }"></video>
        }
        <div rtElem="shade"></div>
        <div rtElem="shade-intro" #shadeIntro></div>

        <div rtElem="intro" #intro>
            <h1 rtElem="title">
                <span i18n="@@homeHeroH1L1">Рассчитать</span>
                &ngsp;
                <span i18n="@@homeHeroH1L2">лестницу —</span>
                &ngsp;
                <em rtElem="title-em" i18n="@@homeHeroH1L3">за пять минут,</em>
                &ngsp;
                <span i18n="@@homeHeroH1L4">без AutoCAD.</span>
            </h1>
            <p rtElem="lede" i18n="@@homeHeroLede">
                Онлайн-конструктор для столярных мастерских и частных застройщиков. Геометрия по СНиП и ГОСТ, валидация нормативов, оценка
                объёма древесины и экспорт в JSON, PNG и DXF — в браузере, без бэкенда.
            </p>
            <div rtElem="actions">
                <a rtButton rtElem="action" routerLink="/calc/straight" qa-dataid="home-hero-start" i18n="@@homeCtaStart">
                    Открыть конструктор
                </a>
                <a
                    rtButton
                    rtElem="action"
                    appearance="outlined"
                    routerLink="/about"
                    qa-dataid="home-hero-about"
                    i18n="@@homeCtaAbout"
                    [rtMod]="{ ghost: true }">
                    О проекте
                </a>
            </div>
            <div rtElem="stats">
                <div rtElem="stat">
                    <b rtElem="stat-num">4</b>
                    <span rtElem="stat-label" i18n="@@homeStat1">типа лестниц</span>
                </div>
                <div rtElem="stat">
                    <b rtElem="stat-num">6</b>
                    <span rtElem="stat-label" i18n="@@homeStat2">пород дерева</span>
                </div>
                <div rtElem="stat">
                    <b rtElem="stat-num">100%</b>
                    <span rtElem="stat-label" i18n="@@homeStat4">клиентский расчёт</span>
                </div>
            </div>
        </div>

        <div rtElem="cards">
            @for (card of cards(); track card.kicker) {
                <article rtElem="card" #card qa-dataid="home-hero-card">
                    <p rtElem="kicker">{{ card.kicker }}</p>
                    <h2 rtElem="card-title">
                        {{ card.title }}
                        @if (card.titleEm) {
                            <em rtElem="card-title-em">{{ card.titleEm }}</em>
                        }
                    </h2>
                    @if (card.text) {
                        <p rtElem="card-text">{{ card.text }}</p>
                    }
                    @if (card.rows.length) {
                        <dl rtElem="spec">
                            @for (cardRow of card.rows; track $index) {
                                <dt rtElem="spec-label">{{ cardRow.label }}</dt>
                                <dd rtElem="spec-value" [rtMod]="{ ok: cardRow.ok }">{{ cardRow.value }}</dd>
                            }
                        </dl>
                    }
                    @if (card.cta; as cta) {
                        <a rtButton rtElem="action" qa-dataid="home-hero-card-cta" [rtMod]="{ card: true }" [routerLink]="cta.link">
                            {{ cta.label }}
                        </a>
                    }
                </article>
            }
        </div>

        <div rtElem="rail" aria-hidden="true">
            <div rtElem="rail-fill" #railFill></div>
            @for (card of cards(); track card.kicker) {
                <div rtElem="tick" [style.top.%]="card.from * 100"></div>
            }
        </div>

        <div rtElem="hint" #hintBox qa-dataid="home-hero-hint" aria-live="polite">
            @switch (hint()) {
                @case (Hint.Loading) {
                    <span rtElem="hint-bar"></span>
                    <span i18n="@@homeHeroHintLoading">Загрузка</span>
                    &ngsp;{{ percent() }}%
                }
                @case (Hint.ScrollLoading) {
                    <span i18n="@@homeHeroHintScroll">Листайте</span>
                    &ngsp;
                    <span rtElem="hint-arrow">↓</span>
                    &ngsp;· {{ percent() }}%
                }
                @default {
                    <span i18n="@@homeHeroHintScroll">Листайте</span>
                    &ngsp;
                    <span rtElem="hint-arrow">↓</span>
                }
            }
        </div>
    </section>
</ng-container>
